import React from "react";
import "./TrustBand.css";

const DEFAULT_ITEMS = [
  {
    label: "Records you can review",
    body: "Inventory, range logs, notes, photos, and maintenance details stay organized around the items and sessions they belong to.",
  },
  {
    label: "Built for normal routines",
    body: "Add enough structure to be useful later without turning ownership or range days into admin work.",
  },
  {
    label: "Connected by real use",
    body: "Firearms, accessories, round counts, photos, and visits stay connected so history is easier to understand.",
  },
  {
    label: "Clear support path",
    body: "Product questions and setup feedback have a direct support email instead of leaving owners guessing.",
  },
];

function TrustBand({
  eyebrow = "Built for real records",
  title = "Built for firearm owners who want useful records without a heavy workflow.",
  items = DEFAULT_ITEMS,
  ctaHref = "/faq",
  ctaLabel = "Read the FAQ",
  className = "",
}) {
  return (
    <section className={`trust-band ${className}`.trim()} aria-labelledby="trust-band-title">
      <div className="trust-band-copy">
        <div className="trust-band-eyebrow">{eyebrow}</div>
        <h2 id="trust-band-title">{title}</h2>
        {ctaHref && (
          <a className="trust-band-link" href={ctaHref}>
            {ctaLabel}
          </a>
        )}
      </div>
      <div className="trust-band-items" aria-label="Range Pocket trust points">
        {items.map((item) => (
          <article key={item.label}>
            <strong>{item.label}</strong>
            <p>{item.body}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default TrustBand;
